<template>
  <div class="pointPositionManage-container">
    <el-aside class="container-left">
      <el-row class="title-row" :gutter="20">
        <!-- <el-col :span="16"> -->
        <p class="area-title">区域列表</p>
        <!-- </el-col> -->
        <!-- <el-col :span="2" :offset="6">
          <div
            @click="addArea"
            v-if="hasPerm('sys:area:save')"
            class="blue-add iconfont icon-plus-full"
            style="cursor: pointer"
          ></div>
        </el-col> -->
      </el-row>
      <div>
        <div class="custom-tree-container">
          <div class="block">
            <el-tree
              :data="areaTreeData"
              node-key="id"
              @node-click="clickArea"
              highlight-current
              :expand-on-click-node="false"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <span>{{ node.label }}</span>
                <!-- <div class="is-show">
                  <span style="display: none">
                    <span
                      @click="editArea(node)"
                      v-if="hasPerm('maintain:dept:group:update')"
                      class="iconfont icon-edit"
                    ></span>
                    <span
                      @click="removeArea(node)"
                      v-if="hasPerm('maintain:dept:group:delete')"
                      class="iconfont icon-delete"
                    ></span>
                  </span>
                </div> -->
              </span>
            </el-tree>
          </div>
        </div>
      </div>
    </el-aside>
    <div class="container-right">
      <el-row class="title-row">点位列表</el-row>
      <div class="right-content">
        <el-row>
          <el-form inline :model="queryForm" ref="queryForm">
            <el-form-item class="r-20" prop="monitoringNo">
              <el-input
                placeholder="监测编号"
                v-model.trim="queryForm.monitoringNo"
                @keyup.enter.native="query"
              ></el-input>
            </el-form-item>
            <el-form-item class="r-20" prop="state">
              <el-select
                v-model="queryForm.state"
                clearable
                placeholder="年度举证完成状态"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="query">查询</el-button>
            <el-button @click="reset">取消</el-button>
            <div style="margin-bottom: 20px">
              <el-button type="primary" @click="addPoint">新增</el-button>
              <el-button size="medium" type="danger" @click="delPoint"
                >删除</el-button
              >
              <el-button type="primary" class="btn-width" @click="clickImport"
                >批量导入</el-button
              >
              <el-button
                type="primary"
                class="btn-width"
                @click="TemplateDownload"
                >模板下载</el-button
              >
            </div>
          </el-form>
        </el-row>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="560px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="24"
            align="center"
            style="padding: 0"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="55"
          ></el-table-column>
          <el-table-column
            prop="monitoringNo"
            label="监测编号"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="areaName"
            label="归属区域"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="patternType"
            label="图斑类型"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="area"
            label="监测面积"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="logGd"
            label="经度"
            min-width="90"
          ></el-table-column>
          <el-table-column
            prop="latGd"
            label="纬度"
            min-width="90"
          ></el-table-column>
          <el-table-column
            prop="state"
            label="年度举证完成状态"
            min-width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.state == 0" class="btn-grey">未完成</span>
              <span v-else-if="scope.row.state == 1" class="btn-org"
                >已到达</span
              >
              <span v-else-if="scope.row.state == 2" class="btn-green"
                >已完成</span
              >
              <span v-else-if="scope.row.state == 3" class="btn-red"
                >未通过</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operationTeam"
            label="作业班组"
            min-width="120"
          >
            <template slot-scope="scope">
              <span class="blue-line" @click="toUnitManage(scope.row)">{{
                scope.row.operationTeam
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click.stop="editPoint(scope.row)"
                >修改</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click.stop="detailInfo(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加区域列表弹框 -->
    <el-dialog
      :title="areaTitle"
      :visible.sync="areaVisible"
      class="mini-dialog"
    >
      <el-form
        :rules="areaRules"
        ref="areaForm"
        :model="areaForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="name" label="区域名称">
          <el-input
            v-model="areaForm.name"
            placeholder="请输入区域名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="areaVisible = false">取 消</el-button>
        <el-button type="primary" @click="areaSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入 -->
    <el-dialog
      title="点位批量导入"
      :visible.sync="importVisible"
      class="mini-dialog"
    >
      <el-form ref="importForm" :model="importForm" size="mini" inline>
        <el-form-item class="upload-box" label="文件名">
          <el-upload
            class="upload-demo"
            ref="upload"
            :with-credentials="true"
            :multiple="false"
            :limit="1"
            accept=".xls, .xlsx"
            :file-list="fileList"
            :on-change="addFile"
            :action="uploadUrl()"
            :http-request="uploadSectionFile"
            :auto-upload="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="importVisible = false">取 消</el-button>
        <el-button type="primary" @click="importCommit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增/修改 点位模态框 -->
    <el-dialog
      :title="pointDialogTitle"
      :visible.sync="pointDialogVisible"
      class="pointDialog"
    >
      <el-form
        :model="pointForm"
        :rules="rules"
        ref="addPoint"
        label-position="left"
        label-width="140px"
      >
        <el-form-item label="监测编码" prop="monitoringNo">
          <el-input
            v-model="pointForm.monitoringNo"
            placeholder="请输入监测编码"
            :disabled="onlyRead"
          ></el-input>
        </el-form-item>
        <el-form-item label="归属区域" prop="areaName">
          <el-select
            v-model="pointForm.areaName"
            placeholder="请选择归属区域"
            :disabled="onlyRead"
          >
            <el-option
              v-for="item in majorList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图斑类型" prop="patternType">
          <el-input
            v-model="pointForm.patternType"
            placeholder="请输入图斑类型"
            :disabled="onlyRead"
          ></el-input>
        </el-form-item>
        <el-form-item label="年度举证完成状态" prop="state">
          <el-select
            v-model="pointForm.state"
            clearable
            placeholder="请选择年度举证完成状态"
          >
            <el-option
              v-for="item in stateList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监测面积" prop="area">
          <el-input
            v-model="pointForm.area"
            placeholder="请输入监测面积"
            :disabled="onlyRead"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="logGd">
          <el-input
            v-model="pointForm.logGd"
            placeholder="请输入经度"
            :disabled="onlyRead"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latGd">
          <el-input
            v-model="pointForm.latGd"
            placeholder="请输入纬度"
            :disabled="onlyRead"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
        <el-button @click="pointDialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog
      title="详情"
      :visible.sync="detailInfoVisible"
      class="mini-dialog info-box"
    >
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">检测编号</el-col>
        <el-col :span="17">{{
          $judgeEmpty(pointInfoData.monitoringNo)
        }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">归属区域</el-col>
        <el-col :span="17">{{ $judgeEmpty(pointInfoData.areaName) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">图斑类型</el-col>
        <el-col :span="17">{{ $judgeEmpty(pointInfoData.patternType) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">监测面积</el-col>
        <el-col :span="17">{{ $judgeEmpty(pointInfoData.area) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">经度</el-col>
        <el-col :span="17">{{ $judgeEmpty(pointInfoData.logGd) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">纬度</el-col>
        <el-col :span="17">{{ $judgeEmpty(pointInfoData.latGd) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">年度举证完成状态</el-col>
        <el-col :span="17">{{ $judgeEmpty(pointInfoData.state) }}</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" class="dialog-label">作业班组</el-col>
        <el-col :span="17">{{
          $judgeEmpty(pointInfoData.operationTeam)
        }}</el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailInfoVisible = false"
          >确 定</el-button
        >
        <el-button @click="detailInfoVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PointPositionManage",
  data() {
    return {
      queryForm: {
        monitoringNo: "",
        state: "",
      },
      tableData: [],
      tableVal: [],
      fileList: [],
      limit: 10,
      currentPage: 1,
      total: 0,
      onlyRead: false,
      pointDialogVisible: false,
      importVisible: false,
      detailInfoVisible: false,
      areaVisible: false,
      isFlag: true,
      pointDialogTitle: "",
      pointInfoData: [],
      majorList: [],
      addAreaList: [],
      pointForm: {
        id: "",
        monitoringNo: "",
        areaName: "",
        patternType: "",
        area: "",
        latGd: "",
        logGd: "",
        state: "",
      },
      stateList: [
        { id: "0", label: "未完成" },
        { id: "1", label: "已到达" },
        { id: "2", label: "已完成" },
        { id: "3", label: "未通过" },
      ],
      importForm: {},
      rules: {
        monitoringNo: [
          {
            required: true,
            trigger: "change",
            message: "请输入监测编码",
          },
        ],
        areaName: [
          {
            required: true,
            trigger: "change",
            message: "请选择归属区域",
          },
        ],
        patternType: [
          {
            required: true,
            trigger: "change",
            message: "请输入图斑类型",
          },
        ],
        state: [
          {
            required: true,
            trigger: "change",
            message: "请选择年度举证完成状态",
          },
        ],
        area: [
          {
            required: true,
            trigger: "change",
            message: "请输入监测面积",
          },
        ],
        logGd: [
          {
            required: true,
            trigger: "change",
            message: "请输入经度",
          },
        ],
        latGd: [
          {
            required: true,
            trigger: "change",
            message: "请输入纬度",
          },
        ],
      },
      areaTreeData: [],
      areaTitle: "",
      editTag: "0",
      areaForm: { name: "" },
      areaRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入区域名称",
          },
        ],
      },
    };
  },
  watch: {
    areaTreeData(val) {
      console.log(val);
      if (val) {
        this.$nextTick(() => {
          let node = document.querySelectorAll(".el-tree-node__content");
          node[node.length - 1].click();
        });
      }
    },
  },
  created() {
    this.getAreaList();
  },
  methods: {
    clickArea(areaDatas) {
      console.log(areaDatas);
      this.pAreaId = areaDatas.id;
      this.pointForm.areaId = areaDatas.id;
      this.areaForm.pName = areaDatas.label;
      //表格数据调取
      this.getPointList();
    },
    // // 区域列表添加
    // addArea() {
    //   console.log("区域列表添加");
    //   this.editTag = "0";
    //   this.$resetForm(this, "areaForm");
    //   this.areaVisible = true;
    //   this.areaTitle = "新增区域";
    // },
    // // 修改区域名称
    // editArea(node) {
    //   console.log(node);
    //   this.editTag = "1";
    //   this.$resetForm(this, "areaForm");
    //   this.areaVisible = true;
    //   this.areaTitle = "修改区域名称";
    //   this.areaForm.name = node.label;
    // },
    // // 删除区域名称
    // removeArea(node) {
    //   console.log(node);
    //   // let areaId = node.data.areaId;
    //   this.$confirm("确定删除吗？", "系统提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   });
    //   // .then(async () => {
    //   //   let { data: res } = await this.$axios.delete(
    //   //     "/api/maintain/dept/group/" + groupId
    //   //   );
    //   //   if (res.code == 1) {
    //   //     this.$message.success("操作成功");
    //   //     this.getAreaList();
    //   //   } else {
    //   //     this.$message.warning(res.msg);
    //   //   }
    //   // });
    // },
    areaSubmit() {
      let parm = {};
      // 添加接口
      if (this.editTag == "0") {
        parm = {
          deptId: this.addId,
          name: this.areaForm.name,
        };
      } else {
        parm = {
          groupId: this.editId,
          name: this.areaForm.name,
        };
      }

      // let data = [];
      this.$refs.areaForm.validate(async (valid) => {
        if (valid) {
          if (this.editTag == "0") {
            console.log(parm, "添加");
            // data = await this.$axios.post("/api/maintain/dept/group", parm);
          } else {
            console.log(parm, "修改");
            // data = await this.$axios.patch("/api/maintain/dept/group", parm);
          }
          // let res = data.data;
          // if (res.code == 1) {
          //   this.$message.success("操作成功");
          //   this.getAreaList();
          this.areaVisible = false;
          // } else {
          //   this.$message.warning(res.msg);
          // }
        }
      });
    },
    // 新增点位
    addPoint() {
      //清空表单数据
      this.$resetForm(this, "addPoint");
      this.pointDialogVisible = true;
      this.editTag = false;
      this.onlyRead = false;
      this.pointDialogTitle = "新增点位";
      // 获取单位名称列表数据
      this.majorList = this.addAreaList;
    },
    // 修改点位
    editPoint(row) {
      console.log(row);
      let {
        id,
        monitoringNo,
        areaName,
        patternType,
        area,
        logGd,
        latGd,
        state,
      } = row;
      this.pointForm = {
        id: id,
        monitoringNo: monitoringNo,
        areaName: areaName,
        patternType: patternType,
        area: area,
        logGd: logGd,
        latGd: latGd,
        state: state,
      };
      // this.pointForm = { ...row };
      this.pointDialogVisible = true;
      this.editTag = true;
      this.onlyRead = true;
      this.pointDialogTitle = "修改点位信息";
    },
    // 新增或修改点位确认按钮
    saveOrUpdate() {
      let value = [];
      this.$refs.addPoint.validate(async (valid) => {
        // 通过props验证才可以新增或者修改数据
        if (valid) {
          if (this.editTag) {
            console.log("修改");
            value = await this.$axios.patch(
              "/api/regional/point",
              this.pointForm
            );
          } else {
            console.log("新增");
            value = await this.$axios.post(
              "/api/regional/point",
              this.pointForm
            );
          }
          let res = value.data;
          console.log(res);
          if (res.code == 1) {
            //信息提示
            this.$message.success("操作成功");
            //刷新表格
            this.getPointList();
            this.pointDialogVisible = false;
          } else {
            // 后端返回验证判断
            this.$message.warning(res.msg);
          }
        }
      });
    },
    // 跳转到单位管理页面
    toUnitManage(row) {
      this.$router.push("/UnitManagement");
      sessionStorage.setItem("devopsDeptId", row.deptId);
    },
    query() {
      console.log(this.queryForm);
      this.getPointList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getPointList();
    },
    // 多选删除
    delPoint() {
      let pointIds = this.$getIds(this.tableVal);
      if (!pointIds) {
        return;
      }
      console.log(pointIds);
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.delete("/api/regional/point", {
          data: JSON.stringify(pointIds),
        });
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          // 重新获取表数据[刷新]
          this.getPointList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    /** 批量导入-start- */
    clickImport() {
      this.fileList = [];
      this.importVisible = true;
    },
    addFile(file, fileList) {
      this.fileList = fileList;
      //限制上传文件为5M
      this.fileSizeIsSatisfy = file.size < 5 * 1024 * 1024 ? true : false;
      // 从文件名 .后面开始截取，截取扩展名
      this.extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(file.type, this.extension);
    },
    uploadUrl() {
      return "/api/regional/point/import";
    },
    async uploadSectionFile(parm) {
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      let { data: res } = await this.$axios.post(
        "/api/regional/point/import",
        form
      );
      if (res.code == 1) {
        this.$message.success("导入成功");
        this.getPointList();
        this.importVisible = false;
        //导入成功后清空upload
        this.$refs.upload.clearFiles();
        this.fileList = [];
      } else {
        this.$refs.upload.clearFiles();
        this.fileList = [];
        this.$message.warning(res.msg);
      }
    },
    async importCommit() {
      if (this.fileList.length <= 0) {
        this.$message.warning("请至少上传一个文件！");
        return;
      }
      if (this.extension !== "xlsx" && this.extension !== "xls") {
        this.$message.warning("上传失败！请上传excel表格文件！");
        this.$refs.upload.clearFiles();
        this.fileList = [];
        return;
      }
      if (!this.fileSizeIsSatisfy) {
        this.$message.warning("上传失败！文件大小超过5M！");
        this.$refs.upload.clearFiles();
        this.fileList = [];
        return;
      }
      this.$refs.upload.submit();
    },
    /** 批量导入-end- */

    // 模板下载
    TemplateDownload() {
      this.$confirm(`确定下载该模板吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 确定操作
          window.location.href = "/api/regional/point/template";
        })
        .catch(() => {
          // 取消操作
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      // 选中的表格数据 row
      console.log(val);
      this.tableVal = val;
    },

    // 详情模态框
    detailInfo(row) {
      this.detailInfoVisible = true;
      console.log(row);
      this.getPointInfo(row.id);
    },
    async getPointInfo(id) {
      let { data: res } = await this.$axios.get("/api/regional/point/" + id);
      console.log("operationTeam", res);
      if (res.code == 1) {
        this.pointInfoData = res.data;
        let val = Number(this.pointInfoData.state);
        switch (val) {
          case 0:
            this.pointInfoData.state = "未完成";
            break;
          case 1:
            this.pointInfoData.state = "已到达";
            break;
          case 2:
            this.pointInfoData.state = "已完成";
            break;
          case 3:
            this.pointInfoData.state = "未通过";
            break;
          default:
            this.pointInfoData.state = "";
        }
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getAreaList() {
      let { data: res } = await this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        this.handleAreaList(res.data);
        this.areaTreeData = res.data;
        this.pAreaId = res.data[0].id;
        this.pointForm.areaId = res.data[0].id;
        this.areaForm.pName = res.data[0].label;
      } else {
        this.$message.warning(res.msg);
      }
    },

    // 处理弹框下拉框中区域列表数据
    handleAreaList(areaList) {
      // 选中地拍区域
      let photoList = areaList.slice(areaList.length - 1)[0];
      areaList.forEach(() => {
        if (photoList.children.length != 1) {
          this.addAreaList = photoList.children;
        } else {
          this.handleAreaList(photoList.children);
        }
      });
    },

    // 获取点位表格数据
    async getPointList() {
      let obj = {};
      obj.monitoringNo = this.queryForm.monitoringNo;
      obj.operationTeam = this.operationTeam;
      obj.state = this.queryForm.state;
      obj.areaId = this.pAreaId;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let { data: res } = await this.$axios.get("/api/regional/point/list", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getPointList();
    },
  },
};
</script>

<style lang='scss' scoped>
.pointPositionManage-container {
  display: flex;
  height: calc(100% - 40px);
  margin: 20px;
  background: #fff;
  .title-row {
    font-weight: 700;
    padding-bottom: 10px;
    border-bottom: 1px solid #c9c9c9;
  }
  .container-left {
    padding: 20px 10px;
    border-right: 1px solid #c9c9c9;
    .blue-add {
      color: #108ee9;
    }
  }
  .container-right {
    width: 100%;
    padding: 20px 10px;
    background: #fff;
    .right-content {
      padding-top: 10px;
    }
  }
  .r-10 {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  ::v-deep .el-aside {
    margin: 0;
  }
  ::v-deep .el-form-item__content {
    width: 260px;
  }
  .btn-green {
    color: #02d34c;
  }
  .btn-red {
    color: #f6392a;
  }
  .btn-org {
    color: #ff9000;
  }
  .btn-grey {
    color: #999;
  }
  .blue-line {
    cursor: pointer;
    color: #108ee9;
    // text-decoration-line: underline;
  }
  .pointDialog /deep/ .el-form-item__content {
    width: 360px;
  }
  .upload-box /deep/ .el-form-item__label {
    padding-left: 11px;
    position: relative;
  }
  .upload-box /deep/ .el-form-item__label::before {
    content: "*";
    color: #f56c6c;
    position: absolute;
    left: 0px;
    top: 1px;
  }
  // 详情弹窗
  .info-box /deep/ .el-dialog__body {
    color: #333;
  }
  .info-box /deep/ .el-dialog__body {
    padding-left: 40px;
  }
  .info-box /deep/ .el-dialog__footer {
    padding-top: 10px;
  }
  .dialog-label {
    padding-left: 20px;
    font-weight: bold;
  }
  .info-box /deep/ .el-row {
    height: 34px;
    line-height: 34px;
  }

  .custom-tree-container {
    padding-top: 10px;
    .is-show {
      height: 28px;
      line-height: 28px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      padding: 0 14px;
      cursor: pointer;
    }
    .is-show:hover :nth-child(1) {
      display: inline-block !important;
    }
    .is-show:hover {
      background: #f5f7fa;
    }
    .active {
      background: #ddf0fe !important;
      color: #0094ff;
    }
  }
}
</style>